import { Quote } from "lucide-react";
import { PROOF } from "@/content/copy";

export default function Proof() {
  return (
    <section data-testid="proof-section" className="py-20 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-sm font-bold uppercase tracking-widest text-terracotta">{PROOF.overline}</p>
        <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-navy">{PROOF.title}</h2>

        <figure
          data-testid="client-story"
          className="mt-10 rounded-2xl bg-white border border-border p-8 lg:p-12 max-w-4xl"
        >
          <Quote className="w-8 h-8 text-terracotta" aria-hidden="true" />
          <blockquote className="mt-4 text-lg sm:text-xl text-navy/80 leading-relaxed font-medium">
            {PROOF.story.quote}
          </blockquote>
          <figcaption className="mt-6">
            <p className="text-base font-semibold text-navy">{PROOF.story.outcome}</p>
            <p className="mt-1 text-sm text-navy/50">{PROOF.story.attribution}</p>
          </figcaption>
        </figure>
      </div>
    </section>
  );
}
